import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PopupContent, WaremaButton } from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-new-version-modal',
    templateUrl: './new-version-modal.component.html',
    styleUrls: ['./new-version-modal.component.scss'],
    imports: [TranslatePipe, WaremaButton],
})
export class NewVersionModalComponent extends PopupContent<boolean> {}
